import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
let token: any = localStorage.getItem('credentials')
export async function transfer_form(form:any) {    
    return axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LIMOOME_SERVER}/external-sale/transfer-payment`, form, {
    }).then(res => {
        console.log('transfer res: ', res);
        return res
    })

}